// IMPORTS
//-------------------------------------------------------------------------------------------------------------------------
//Angular
import { Component, ChangeDetectorRef } from '@angular/core';
import { Router } from '@angular/router';

//Services
import { WebServices } from '../../shared/services/webServices';

//Config/Globals
import { appConfig } from '../../shared/appConfig.js';

@Component({
    template : '<div style="padding:10px">\n    <h1>Test Harness</h1>\n\n    <div style="margin:10px 0 10px 10px;" id="loginMessage"></div>\n    \n    <select [(ngModel)]="selectedRole" (change)="RoleSelectionChanged();" [attr.disabled]="disableControls ? \'\' : null">\n        <option *ngFor="let role of roles" [ngValue]="role">{{role.name}}</option>\n    </select>\n\n\n    <div style="margin-bottom:15px;"></div>\n\n    <select *ngIf="selectedRole.roleType == \'state\' && selectedRole.type == \'facade\'" [(ngModel)]="selectedState" (change)="StateSelectionChanged()" [attr.disabled]="disableControls ? \'\' : null">\n        <option *ngFor="let state of states" [ngValue]="state">{{state.name}}</option>\n    </select>\n\n    <hr />\n    <div>\n        <button class="btn btn-primary" (click)="NavigateToPublic()" [attr.disabled]="disableControls ? \'\' : null">Public Site</button>\n    </div>\n</div>\n<hr />\n',
    styles : ['.tabs{margin-left:15px;display:flex}.tabs>div{color:#555555;padding:10px;background-color:#e1e1f1;margin-right:5px;border-radius:5px 5px 0px 0px;font-weight:bold;margin-bottom:1px}.tabs>div.selected{margin-bottom:0px;background-color:#d1d1ff;color:#333333;box-shadow:3px -2px 5px 0 #aaaaaa}.tab-body{border:solid 1px #777777;border-radius:5px;padding:20px;margin:5px;margin-top:-1px;box-shadow:3px 5px 5px 0 #aaaaaa}'],
    providers : [
    ]
})
export class TestHarnessComponent{

    // MEMBERS
    //-------------------------------------------------------------------------------------------------------------------------
    disableControls = false;
    showStateList = false;
    selectedState;
    selectedRole;
        
    roles = [];
    states = [];
    

    // INITIALIZATION
    //-------------------------------------------------------------------------------------------------------------------------
    //==================================
    // constructor
    //==================================
    constructor(router: Router, webServices: WebServices, changeDetector: ChangeDetectorRef){

        this.constructor.mapParams( this, arguments );

        this._appConfig = appConfig;

        if (!this._appConfig.ALLOW_TEST_HARNESS){
            this.NavigateToPublic();
        }

        this.InitRoles();
        this.InitStates();

    }; 

    //==================================
    // ngAfterViewChecked
    //==================================
    ngAfterViewChecked() {
        this.changeDetector.detectChanges(); //Death to Angular
    }

    //==================================
    // ngOnInit
    //==================================
    ngOnInit() {
        this.selectedRole = this.roles[0];
        this.selectedState = this.states[0];
    }


    // BL FUNCTIONS
    //-------------------------------------------------------------------------------------------------------------------------
    //==================================
    // FacadeLogin
    //==================================
    FacadeLogin() {

        this.disableControls = true;
        document.getElementById("loginMessage").innerHTML = "Calling session login service...";

        //Note, the service ignores state info for *non-state* logins, so no need to worry about what's in it here.
        this.webServices.Post("/session/facadeLogin",
            {
                id: this.selectedRole.id,
                referrer: window.location.href.replace(/test\-harness/g, ""),
                stateAbrv: this.selectedState.abrv,
                stateCode: this.selectedState.code,
                stateName: this.selectedState.name
            })
            .then(res => {
                console.log("[SessionController:/session/facadeLogin] - res:", res);

                document.getElementById("loginMessage").innerHTML = res.message;

                if (res.success) {
                    sessionStorage.setItem('token', res.jwt);
                    window.location.href = res.redirect;
                }

                this.disableControls = true;
            })
            .catch(err => {
                console.log(err);
                this.disableControls = true;
            })
    }

    //==================================
    // ImpersonationLogin
    //==================================
    ImpersonationLogin() {

        this.disableControls = true;
        document.getElementById("loginMessage").innerHTML = "Calling session login service...";

        this.webServices.Post("/session/impersonate",
            {
                id: this.selectedRole.id,
                referrer: window.location.href.replace(/test\-harness/g, "")
            })
            .then(res => {
                console.log("[SessionController:/session/impersonate] - res:", res);

                document.getElementById("loginMessage").innerHTML = res.message;

                if (res.success) {
                    sessionStorage.setItem('token', res.jwt);
                    window.location.href = res.redirect;
                }
                this.disableControls = true;
            })
            .catch(err => {
                console.log(err);
                this.disableControls = true;
            })

    }

    //==================================
    // InitRoles
    //==================================
    InitRoles() {
        
        this.roles = [
            { id: "", type: "", name: "Select Role", roleType: "" },
            { id: "", type: "", name: "--------------------------------", roleType: "" },
            { id: "f_nds", type: "facade", name: "National Data Steward", roleType: "national" },
            { id: "f_ndds", type: "facade", name: "National Discipline Data Steward", roleType: "national" },
            { id: "f_sds", type: "facade", name: "State Data Steward", roleType: "state" },
            { id: "f_ts", type: "facade", name: "Tech Support", roleType: "tech" },
            { id: "", type: "", name: "--------------------------------", roleType: "" },
            { id: "i_nds", type: "impersonate", name: "Bill Reck (NDS)", roleType:"national" },
            { id: "i_sds_de", type: "impersonate", name: "Sally Kepfer (SDS: Delaware)", roleType:"state" },
            { id: "i_ts", type: "impersonate", name: "Jim Koontz (Tech Support)", roleType: "tech" }
        ];

    }

    //==================================
    // InitStates
    //==================================
    InitStates() {

        //This is just a tst harness, so we don't need all the states.  I'll add a few here.  If you need a new one, just add it on to this list
        this.states = [
            { abrv: "", code: "" , name: "Select a State" },
            { abrv: "CO", code: "08", name: "Colorado" },
            { abrv: "DE", code: "10", name: "Delaware" },
            { abrv: "FL", code: "12", name: "Florida" },
            { abrv: "HI", code: "15", name: "Hawaii" }
        ];
    }

    //==================================
    // NavigateToPublic
    //==================================
    NavigateToPublic(){
        this.router.navigate(["/publicView"]);
    }

    //==================================
    // RoleSelectionChanged
    //==================================
    RoleSelectionChanged(){

        // Jump out if a non-role is selected
        if (this.selectedRole.id == ""){ return; }

        // Is this an impersonation login?
        if (this.selectedRole.type == "impersonate") {
            this.ImpersonationLogin();
        }

        // Is this a facade login
        if (this.selectedRole.type == "facade") {

            //State logins are handled elsewhere
            if (this.selectedRole.roleType != "state") {
                this.FacadeLogin();
            }
        }
            
    }

    //==================================
    // StateSelectionChanged
    //==================================
    StateSelectionChanged() {
        //We can only be here i the user has selected the SDS Facade
        this.FacadeLogin();
    }


        
}
